export const ROOT = '/addressbook';
export const MODULE = 'ADDRESSBOOK';
export const VALUE_KEY = "addressbook"
